// "How easy was that?" - asked right after something a person came to do:
// publishing a listing, contacting a seller or an agency, printing a
// calculator's PDF. Any page asks by calling askForRating(); the host mounted
// once in the root layout (components/RatingHost.tsx) decides whether to show
// it: at most once in 90 days per browser, unless the person opened it
// themselves from the footer.

import type { RatingContext } from '@/lib/feedback';

import { sendToWidget } from '@/lib/late-widgets';

export const RATING_EVENT = 'rec:rate';
export const RATING_INTERVAL_DAYS = 90;
export const RATING_STORAGE_KEY = 'rec:rating:last-asked';

export type RatingRequest = { context: RatingContext; force?: boolean };

export function askForRating(context: RatingContext, force = false) {
  if (typeof window === 'undefined') return;
  // RatingHost loads once the page is ready; a request sent before waits for it.
  sendToWidget(RATING_EVENT, { context, force } satisfies RatingRequest);
}

/** Whether a prompt may be shown now, given when the last one was (ms since the epoch, or null). */
export function mayAsk(lastAsked: number | null, now = Date.now()): boolean {
  if (!lastAsked || !Number.isFinite(lastAsked)) return true;
  return now - lastAsked >= RATING_INTERVAL_DAYS * 24 * 60 * 60 * 1000;
}
